module.exports = __webpack_public_path__ + "static/img/pass.02153b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pass.png
// module id = mA9H
// module chunks = 1